import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Button} from "@material-ui/core";
import {irdaList} from "../../../lists/irda-list";
import {getIrdaSettings, updateIrdaSettings} from "../../../services/irdaSettings.service";
import {IrdaStatus} from "../../../enums/irda-status";
import {addNotification, NotificationType} from "../../../utils/addNotification";
import Loader from "react-loader-spinner";
import {getAllNames} from "../../../services/names.service";
import {optionalMenuDevice} from "../optional-menu-items";
import _ from "lodash";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TimeModalForm from "../../../components/modals/time-modal/time-modal";


interface IIrdaSettingsChild {
    label: string;
    disabled?: boolean;
    onOn: () => void;
    onOff: () => void;
}

const IrdaSettingsChild: React.FC<IIrdaSettingsChild> = (props) => {
    const {t} = useTranslation();
    return (
        <div className='card default-small-card'>
            <div className="card-body">
                <div className='d-flex justify-content-center'>
                    <span>{props.label}</span>
                </div>
                <div className='d-flex justify-content-around mt-3'>
                    <Button variant="contained" disabled={props.disabled} onClick={props.onOn}  type='button' color="primary" className='modal-default-button'>
                        {t('on')}
                    </Button>
                    <Button variant="outlined" disabled={props.disabled} onClick={props.onOff} type='button' color="primary" className='modal-default-button'>
                        {t('off')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

const COUNTER_NUMBER = 13;

export const IrdaSettings: React.FC = () => {
    const {t} = useTranslation();
    const [settingsStatus, setSettingsStatus] = useState({
        status: false,
        responseStatus: false
    });
    const [loading, setLoading] = useState(true);
    const [counter, setCounter] = useState(COUNTER_NUMBER);
    const [currentIrda, setCurrentIrda] = useState({key: '', status: false})
    const handleSubmit = (status: boolean, key: string) => {
        setSettingsStatus({
            status: true,
            responseStatus: false
        });
        setCounter(0);
        updateIrdaSettings(key, status);
        setCurrentIrda({status, key});
    }
    useEffect(() => {
        getAllNames().then(
            (res) => {
                irdaList.map((item) => {
                    _.assign(item, {
                        label: _.get(res, 'irda.' + item.key, item.key)
                    })
                    return item;
                });
                setLoading(false);
            }
        )
            .catch((err) => setLoading(false))
    }, [])
    useEffect(() => {
        const interval = setInterval(() => {
            if (counter < COUNTER_NUMBER) {
                loadData();
                setCounter(counter + 1);
            } else {
                if (settingsStatus.status) {
                    if (settingsStatus.responseStatus) {
                        addNotification({
                            title: t('irdaSettings.updated.title'),
                            text: t('irdaSettings.updated.text'),
                            type: NotificationType.SUCCESS
                        });
                    } else {
                        addNotification({
                            title: t('irdaSettings.notUpdated.title'),
                            text: t('irdaSettings.notUpdated.text'),
                            type: NotificationType.DANGER
                        });
                    }
                    setSettingsStatus({
                        status: false,
                        responseStatus: false
                    });
                }
            }
        }, 1000);

        return () => clearInterval(interval);
    });
    const loadData = () => {
        getIrdaSettings(currentIrda.key, currentIrda.status).then(
            (res) => {
                if ((res === IrdaStatus.TRIGGER) && !settingsStatus.status) {
                    setSettingsStatus({
                        status: true,
                        responseStatus: false
                    });
                } else if (res === IrdaStatus.DONE && settingsStatus.status) {
                    setSettingsStatus({
                        status: true,
                        responseStatus: true
                    });
                    setCounter(COUNTER_NUMBER)
                } else if (res === IrdaStatus.ERROR && settingsStatus.status) {
                    setSettingsStatus({
                        status: true,
                        responseStatus: false
                    });
                    setCounter(COUNTER_NUMBER)
                } else if (res === IrdaStatus.TRIGGER_ACCEPTED && !settingsStatus.status) {
                    setSettingsStatus({
                        status: true,
                        responseStatus: false
                    })
                }
            }
        ).catch(() => setSettingsStatus({
            status: false,
            responseStatus: false
        }))

    }
    if (!loading) {
        return (
            <div className='d-flex justify-content-center w-100 align-items-start router-container'>
                <Modal isOpen={settingsStatus.status}>
                    <ModalBody className='d-flex flex-column justify-content-around align-items-center'>
                        <Loader
                            type="Puff"
                            color="#555374"
                            height={100}
                            width={100}
                            timeout={3000} //3 secs

                        />
                        <span className='mt-3 text-center'>{t(currentIrda.status ? 'irdaLoadingOn' : 'irdaLoadingOff')}</span>
                    </ModalBody>
                </Modal>
                <div className='card default-card w-100'>
                    <div className="card-body">
                        <div className='card-title-container'>
                            <span className='card-title'>{t('irdaSettings')}</span>
                        </div>
                        <div className='d-flex flex-wrap justify-content-around ml-auto'>
                            {
                                irdaList.map((irda) => <IrdaSettingsChild disabled={settingsStatus.status} onOn={() => handleSubmit(true, irda.key)} onOff={() => handleSubmit(false, irda.key)} label={irda.label}/>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}